// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__bubYL","avatarImage":"avatar_avatarImage__-YCg4"};